// Dynamic styles based on theme - to be used with useThemedStyles.
export const createStockDeliveryDetailStyles = ({ ui: { colors, type, space } }) => ({
	container: {
		flex: 1,
	},
	contentContainer: {
		paddingHorizontal: space.gutter,
		paddingTop: 20,
		paddingBottom: space.xl,
	},
	heading: {
		...type.title,
		color: colors.text,
		marginBottom: space.lg,
	},
	summaryCard: {
		gap: space.sm,
		marginBottom: space.xl,
	},
	summaryRow: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		gap: space.lg,
	},
	label: {
		...type.secondary,
		color: colors.textSecondary,
		flex: 1,
	},
	value: {
		...type.secondaryStrong,
		flex: 2,
		color: colors.text,
		textAlign: 'right',
	},
	valueLink: {
		color: colors.accent,
		textDecorationLine: 'underline',
	},
	valueComplete: {
		color: colors.success,
	},
	sectionTitle: {
		marginBottom: space.md,
	},
	itemsHeaderActions: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		gap: space.sm,
		marginBottom: space.md,
	},
	itemsHeaderAction: {
		flexGrow: 1,
		flexBasis: 140,
	},
	helperText: {
		...type.secondary,
		color: colors.textSecondary,
		marginBottom: space.md,
	},
});
